export default "__VITE_ASSET__C3PlApnx__"